import { useFm } from '@web3/base-hooks';
import { BoxedSelect } from '@bfe/moly';
import { ShowType } from '@/types/account';
import cls from 'classnames';
import styles from './index.module.less';

const BoxedSelectGroup = BoxedSelect.Group;

interface Props {
  choice: ShowType;
  setChoice: (v: ShowType) => void;
}

export const Choose = (props: Props) => {
  const { choice, setChoice } = props;
  const fm = useFm();

  const onChangeBox = (newValue: string) => {
    if (!newValue) return;
    setChoice(Number(newValue) as ShowType);
  };

  const list = [
    {
      title: fm('delayRedemption'),
      subTitle: fm('principalPlusAllInt'),
      desc: fm('t4DayRedemption'),
      type: ShowType.DelayUnStake,
    },
    {
      title: fm('immediateRedemption'),
      subTitle: fm('principalPlusPartInt'),
      desc: fm('immediateLossRedem'),
      type: ShowType.Unstake,
    },
  ];

  return (
    <>
      <div className={styles.desc}>
        {list.filter((item) => item.type === choice)?.[0]?.desc}
      </div>
      <BoxedSelectGroup value={String(choice)} onChange={onChangeBox}>
        {list.map((item) => {
          return (
            <BoxedSelect
              value={String(item.type)}
              key={item.type}
              className={cls(
                styles.boxSelect,
                item.type === choice ? styles.selected : ''
              )}
            >
              <div className="px-[20px] py-[16px]">
                <div className="text-[16px] leading-[24px] font-[600] text-base-bds-gray-t1-title">
                  {item.title}
                </div>
                <div className="text-[14px] leading-[22px] font-[400] text-base-bds-gray-t2">
                  {item.subTitle}
                </div>
              </div>
            </BoxedSelect>
          );
        })}
      </BoxedSelectGroup>
    </>
  );
};
